export var EDragContentOptions;
(function (EDragContentOptions) {
    EDragContentOptions["IMAGE"] = "images";
    EDragContentOptions["IMAGE_360"] = "three_sixty_image";
    EDragContentOptions["AUDIO"] = "audio";
    EDragContentOptions["VIDEO"] = "video";
    EDragContentOptions["VIDEO_360"] = "three_sixty_video";
    EDragContentOptions["MODEL_3D"] = "three_d_model";
    EDragContentOptions["MOVEMENT"] = "movement";
    EDragContentOptions["INFORMATION"] = "information";
    EDragContentOptions["ANSWER"] = "answer";
    EDragContentOptions["QUESTION"] = "question";
})(EDragContentOptions || (EDragContentOptions = {}));
